import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "progress", "share"];
  static values = {
    index: { type: Number, default: 0 },
    shareUrl: String,
    shareTitle: String,
    copiedText: String,
  };

  connect() {
    this.boundHandleOpen = this.handleOpen.bind(this);
    document.addEventListener("click", this.boundHandleOpen);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOpen);
  }

  handleOpen(event) {
    if (!event.target.closest("[data-rewind-open]")) return;
    event.preventDefault();
    WGModal.open("#rewind-overlay");
  }

  next() {
    this.indexValue = Math.min(this.indexValue + 1, this.slideTargets.length - 1);
  }

  previous() {
    this.indexValue = Math.max(this.indexValue - 1, 0);
  }

  share() {
    const url = this.shareUrlValue || window.location.href;

    // navigator.share is unavailable on many desktop browsers (e.g. Firefox),
    // so fall back to copying the link to the clipboard.
    if (navigator.share) {
      navigator.share({ title: this.shareTitle, url }).catch(() => {});
    } else {
      this.copyToClipboard(url);
    }
  }

  copyToClipboard(url) {
    if (!navigator.clipboard) return;

    // Clipboard access can be denied (permissions, non-secure context); there is
    // nothing useful to show the user then, so swallow it like the share call.
    navigator.clipboard.writeText(url).then(() => this.confirmCopied()).catch(() => {});
  }

  confirmCopied() {
    if (!this.hasShareTarget || !this.copiedTextValue) return;

    const label = this.shareTarget.querySelector(".rewind-share-label");
    if (!label) return;

    const original = label.textContent;
    label.textContent = this.copiedTextValue;
    setTimeout(() => {
      label.textContent = original;
    }, 2000);
  }

  indexValueChanged() {
    this.slideTargets.forEach((slide, i) => {
      const active = i === this.indexValue;
      slide.classList.toggle("active", active);
    });

    this.progressTargets.forEach((item, i) => {
      item.classList.toggle("active", i === this.indexValue);
    });
  }

  // The overlay also renders inside the admin modal, where document.title is
  // the title of whatever admin page is behind it rather than the Rewind's.
  get shareTitle() {
    return this.shareTitleValue || document.title;
  }
}
